import { Circle, Fill, Stroke, Style } from 'ol/style';
export default (feature, resolution) => {
    return new Style({
        image: new Circle({
            radius: 5,
            fill: new Fill({
                color: '#a20500',
            }),
            stroke: new Stroke({
                color: 'white',
            }),
        }),
    });
};
